import { Seo } from "@/components/Seo";
import { Reveal, HoldingsWordmark } from "@/components/primitives";

const S = ({ n, title, children }) => (
  <Reveal>
    <div className="mb-8">
      <h2 className="font-display uppercase tracking-wide2 text-base md:text-lg gold-text">{title}</h2>
      <div className="mt-3 space-y-3 text-[var(--bone)]/85 leading-relaxed">{children}</div>
    </div>
  </Reveal>
);

export default function Terms() {
  return (
    <div className="glow-black jmh-page">
      <Seo title="Terms and Conditions" description="Terms and Conditions for Jennae Michelle Holdings LLC." />
      <section className="jmh-section jmh-page-opening">
        <div className="mx-auto jmh-reading-shell">
          <Reveal className="text-center mb-8">
            <h1 className="font-display uppercase tracking-wide2 gold-text mb-8">Terms of Use</h1>
            <HoldingsWordmark size="md" />
          </Reveal>
        </div>
      </section>

      <section className="jmh-section">
        <div className="mx-auto border border-[rgba(180,139,63,0.18)] px-6 md:px-10 py-10 jmh-reading-shell">
          <Reveal>
            <p className="text-[var(--bone)]/85 mb-8">
              <strong className="font-display uppercase tracking-wide2 text-sm gold-text">Terms and Conditions</strong><br />
              Last updated: October 4, 2026<br />Company Name: Jennae Michelle Holdings LLC
            </p>
          </Reveal>

          <S n="1" title="Use of Services">
            <p>Accessing or using our services constitutes agreement to these Terms and Conditions.</p>
            <p>Use of the services must remain consistent with lawful purposes.</p>
          </S>
          <S n="2" title="SMS Messaging Terms">
            <p>Providing a phone number or contacting us does not by itself authorize marketing or automated SMS messages. Any SMS program will request applicable consent separately.</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Message frequency varies</li>
              <li>Message and data rates may apply</li>
              <li>Reply STOP to unsubscribe</li>
              <li>Reply HELP for assistance</li>
            </ul>
          </S>
          <S title="Information and Inquiry Boundaries">
            <p>This public website describes Jennae Michelle Holdings and its organizations. Its content is general information and is not a substitute for individualized legal, medical, tax, investment, or other professional advice. Separate written agreements, where applicable, govern actual services.</p>
            <p>Sending an inquiry does not establish representation, an advisory relationship, or an obligation to accept a matter. Jennae Michelle Holdings is not a law firm. Do not submit urgent requests or confidential records through the public form.</p>
          </S>
          <S title="External Websites">
            <p>Portfolio links may take you to a separate company website. Those websites have their own services, access requirements, and privacy terms. We do not guarantee uninterrupted availability of this website or external services.</p>
          </S>
          <S n="3" title="No Guarantee of Services">
            <p>Communications and inquiries do not guarantee a particular outcome, offer, or result.</p>
            <p>Interactions provide information and remain subject to further review.</p>
          </S>
          <S n="4" title="User Responsibility">
            <p>You are responsible for ensuring that the information you provide is accurate and truthful.</p>
          </S>
          <S n="5" title="Limitation of Liability">
            <p>We are not liable for:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Losses arising from use of this website, to the extent permitted by applicable law</li>
              <li>Delays or failures in communication</li>
              <li>Third-party service interruptions</li>
            </ul>
          </S>
          <S n="6" title="Intellectual Property">
            <p>The content, branding, and materials are the property of Jennae Michelle Holdings LLC. Their use requires permission.</p>
          </S>
          <S n="7" title="Modifications">
            <p>These Terms may be revised at any time. Continued use of the services constitutes acceptance of the revised Terms.</p>
          </S>
          <S n="8" title="Contact Information">
            <p>For questions, contact:</p>
            <p>Email: <a href="mailto:admin@jennaemichelle.com" className="gold-text link-underline">admin@jennaemichelle.com</a></p>
          </S>
        </div>
      </section>
    </div>
  );
}
